var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-box"},[_c('select-image-component',{attrs:{"defaultImage":_vm.mainImageSrc},on:{"fileSelected":_vm.fileSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }